import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

function Header() {
  return (
    <div className='headerComponent'>
        <div className="contents">
            <div className="rowContents">
                <p>Documents</p>
                <Link to="/admin/newDocument">
                    <Button className='submitButton'> Ajouter un document </Button>
                </Link>
            </div>
        </div>
    </div>
  )
}

export default Header
